
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/identity-compliance-checklist",
      function () {
        return require("private-next-pages/tools/identity-compliance-checklist.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/identity-compliance-checklist"])
      });
    }
  